export const getReadOnlySection = () => {
    return [
        {
            id: 'r-4',
            privilege: "Manage Eaters",
            isReadOnly: true
        },
        {
            id: 'r-5',
            privilege: "Manage Drivers",
            isReadOnly: true
        },
        {
            id: 'r-6',
            privilege: "Manage Restaurants",
            isReadOnly: true
        }
    ]
};

export const getReadOnlyUsers = ({ privileges, readOnlyUser, pageType }) => {

    let isReadOnly = false;
    const getPagePrivileges = privileges.find(data => data.permittedUrls.some(val => val == pageType || pageType.startsWith(val) || pageType.endsWith(val)));
    if (getPagePrivileges) {
        const privilegeId = getPagePrivileges.id;
        isReadOnly = readOnlyUser.some(val => val.previlegeId == privilegeId && !val.isReadOnly);
    };

    return isReadOnly;
}